import instance from "../../index";
import {BusinessUnit} from "../../../models/businessUnit";
import {PagedList} from "../../../models/paged-list";
import {ShortDto} from "../../../models/short-dto";
import {UnidadeDeNegociosFilter} from "../../../filters/unidade-de-negocios-filter";
import {CreateBusinessUnitRequest} from "../../../models/requests/create-business-unit-request";
import {EditBusinessUnitRequest} from "../../../models/requests/edit-business-unit-request";
import {BaseResponse} from "../../../models/base-response";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import {useEffect, useState} from "react";

export const useBusinessUnitService = () => {
    //TODO: Anotar isso pra implementar loading e session filter
    const [loading, setLoading] = useState<boolean>(false);
    const [clientId, setClientId] = useState<string>();
    const blockUI = useBlockUI();
    useEffect(() => {
        const clientId = localStorage.getItem('clientId');
        if (clientId) {
            setClientId(clientId);
        }
    }, []);

    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);
    async function activeUnit(id: string): Promise<BusinessUnit> {
        setLoading(true)
        const response = await instance.put<BusinessUnit>(`/v1/backoffice/business-units/${id}/activate`)
            .finally(() => setLoading(false));
        return response.data;
    }
    async function deactiveUnit(id:string ): Promise<BusinessUnit> {
        const response = await instance.put<BusinessUnit>(`/v1/backoffice/business-units/${id}/inactivate`);
        return response.data;
    }

    async function deleteUnit(id: string) {
        return await instance.delete(`/v1/backoffice/business-units/${id}`);
    }
    async function getBusinessUnitById(id: string): Promise<BusinessUnit> {
        const response = await instance.get<BaseResponse<BusinessUnit>>(`/v1/backoffice/business-units/${id}`);
        return response?.data?.data;
    }
    async function getUnits(filter?: UnidadeDeNegociosFilter): Promise<PagedList<BusinessUnit>> {
        const response = (await instance.get<PagedList<BusinessUnit>>('/v1/backoffice/business-units/', {
            params: filter
        }));
        return response.data;
    }

    async function getAllGetUnitsShortDto(filter?: UnidadeDeNegociosFilter): Promise<ShortDto[]> {
        const response = await instance.get<BaseResponse<ShortDto[]>>('/v1/backoffice/business-units/all', {
            params: filter
        });
        return response?.data?.data;
    }
    async function createBusinessUnit(request: Partial<CreateBusinessUnitRequest>): Promise<BusinessUnit> {
        const response = await instance.post<BusinessUnit>(`/v1/backoffice/business-units/`, request);
        return response?.data;
    }

    async function editBusinessUnit(request: Partial<EditBusinessUnitRequest>, id: string | string[] | undefined): Promise<BusinessUnit> {
        const response = await instance.put<BusinessUnit>(`/v1/backoffice/business-units/${id}`, request);
        return response?.data;
    }

    return {
        activeUnit,
        deactiveUnit,
        deleteUnit,
        getBusinessUnitById,
        getUnits,
        getAllGetUnitsShortDto,
        createBusinessUnit,
        editBusinessUnit
    }
}
export default useBusinessUnitService;